<ion-app *ngIf="appLoaded">
  <!--
    The editor is docked next to the page rather than placed inside an ion-split-pane. The
    split pane sets contain: strict, which makes it a stacking context, and anything inside it
    can never be raised above an Ionic modal. Being a direct child of ion-app is what lets the
    panel stay usable, and the pick outline stay visible, while a modal is open.
  -->
  <app-style-configurator *ngIf="showDockedPanel" class="docked-panel"
    (previewModeLoadedEvent)="onPreviewModeLoaded()"></app-style-configurator>

  <div class="ion-page" id="main" [class.beside-docked-panel]="showDockedPanel">
    <!-- Only opens the drawer, so it is only there when the drawer is the placement in use. -->
    <ion-icon *ngIf="showDrawerPanel && previewModeType === 'Edit'" name="color-palette-outline"
      class="theme-configurator-icon" (click)="openThemeConfiguratorMenu()"></ion-icon>
    <ion-content *ngIf="!previewMode || (previewMode && previewModeLoaded)" role="none" id="main-container" attr.aria-label="{{ 'commons.mainContainer' | translate }}">
      <ion-header *ngIf="showMenu()">
        <app-header>
        </app-header>
      </ion-header>
      <app-mobile-menu role="menubar" *ngIf="showMenu()"></app-mobile-menu>
      <ion-router-outlet role="none" id="router-container" [ngClass]="{'margin-header': showMenu()}"></ion-router-outlet>
      <tab-monitor></tab-monitor>
    </ion-content>
  </div>

  <!-- Also a direct child of ion-app: Ionic transforms the page wrapper, and a transformed
       ancestor would make the overlay's fixed positioning relative to it instead of the viewport. -->
  <app-brand-inspector *ngIf="showInspector"></app-brand-inspector>
  <ion-menu side="end" menuId="theme-configurator-menu" *ngIf="showDrawerPanel" contentId="main"
    class="theme-configurator-menu">
    <ion-menu-toggle menu="end">
      <ion-icon class="theme-configurator-close-icon" name="close-circle-outline"></ion-icon>
    </ion-menu-toggle>
    <ion-content role="none" class="ion-padding">
      <app-style-configurator (previewModeLoadedEvent)="onPreviewModeLoaded()"></app-style-configurator>
    </ion-content>
  </ion-menu>
</ion-app>